"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTypeSelector = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var FileIcon_1 = require("components/FileIcon");
var Icon_1 = require("components/Icon");
var fp = require("fp-ts");
var types = [
    'PDF',
    'TEXT',
    'SPREADSHEET',
    'PRESENTATION',
    'IMAGE',
    'DWG',
    'IFC',
    'VIDEO',
    'FOLDER'
];
var FileTypeSelector = function (props) {
    var options = [
        {
            value: 'ANY',
            text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any')
        }
    ].concat(types.map(function (type) {
        var ico = (0, FileIcon_1.typeToIconAndTextMap)(type);
        return {
            value: type,
            text: ico.text,
            leftComponent: ico.icon
        };
    }));
    var selected = props.searchOption.fold(undefined, function (e) { return (0, FileIcon_1.typeToIconAndTextMap)(e); });
    return (React.createElement("div", { className: 'sok-form-field text' },
        React.createElement("div", { className: 'input' },
            React.createElement("label", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type')),
            React.createElement(sok_ui_1.Dropdown2, { alignment: 'center', isOpen: props.isOpen, onChange: function (value) {
                    props.toggle(value);
                } },
                React.createElement("div", { className: 'dropdown-input' },
                    React.createElement("input", { type: 'text', placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any'), value: selected ? selected.text : '' }),
                    React.createElement(Icon_1.Icon, { className: 'fa-caret-down' })),
                React.createElement(sok_ui_1.Dropdown2Menu, { className: 'narrow sok-click-wall advanced-search-dropdown' }, options.map(function (item, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: index, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.toggle();
                        if (item.value === 'ANY') {
                            return props.setSearchType(fp.option.none);
                        }
                        return props.setSearchType(fp.option.some(item.value));
                    } },
                    React.createElement("div", { className: selected && selected.value === item.value ? 'active' : '' },
                        React.createElement("span", { style: { marginRight: '0.8rem' } }, item.leftComponent),
                        React.createElement("label", null, item.text)))); }))))));
};
exports.FileTypeSelector = FileTypeSelector;
